import moment from 'moment';
import { useEffect, useState } from 'react';
import { TableCompHead } from '../../../../../../../components/ui';
import { useQuery } from '../../../../../../../hooks/UseQuery';
import { TableInput } from '../../../../../../../components/common';
import { handleChangeModuleData } from '../../helpers/handleChangeModuleData';
import AutocompleteGridmui from '../../../../../../../components/common/autocomplete/AutocompleteGridmui';
import AutocompleteMuiCustom from '../../../../../../../components/common/AutocompleteMuiCustom';
import axios from 'axios';

interface IProps {
  moduleData: any;
  isView: boolean;
}

const heading = [
  'S. No.',
  'PROCESS PARAMETERS',
  'SPECIFICATIONS',
  'OBSERVATIONS',
  "REMARKS",
];

const THead = ({ moduleData, isView }: IProps) => {
  const [render, setRender] = useState(false);
  const part_no = useQuery('part_no');
  const part_name = useQuery('part_name');
  const due_date = useQuery('dueDate');
  const [departments, setDepartments] = useState([]);
  const [machineData, setMachineData] = useState([]);

  useEffect(() => {
    axios
      .get(`/api/department`)
      .then((res) => setDepartments(res.data.results))
      .catch((err) => console.log(err));
      axios
      .get('/api/machineRoutes/')
      .then((res) => {
        setMachineData(res.data.results);
      })
      .catch((err) => console.log(err));
  }, []);

  console.log("data is",moduleData);
  return (
    <thead>
      <TableCompHead
        colSpan={5}
        rowSpan={3}
        labels={['Doc. No.: ', 'Rev. No.:', 'Eff. Date:']}
        values={['F09SYS04', '01', '02.04.19']}
        heading="PROCESS AUDIT CHECK SHEET"
      />
      {/* <tr style={{ height: '50px' }}>
        <th style={{ fontSize: '20px' }} align="left" colSpan={3}>
          Department/ Section:{' '}
          <AutocompleteMuiCustom
            label={''}
            id="department_name"
            option_name={'department_name'}
            value={moduleData?.department_id || ''}
            arrayofObj={departments}
            onChange={(e: any, value: any) => {
              moduleData.department_id = value;
              setRender((prev) => !prev);
            }}
          />
        </th>
        <th style={{ fontSize: '20px' }} align="left" colSpan={2}>
          Date of Audit: {due_date}
        </th>
      </tr> */}
      <tr style={{ height: '50px' }}>
        <th style={{ fontSize: '20px' }} align="left" colSpan={2}>
          Part Name/No. : {part_no}
        </th>
        <th style={{ fontSize: '20px' }} align="left" colSpan={2}>
        
          Machine No. :-
          {isView ? (
            moduleData?.machine_id?.machine_no
          ) : (
            <AutocompleteMuiCustom
              id="Machine"
              label=""
              option_name="machine_no"
              arrayofObj={machineData}
              value={moduleData?.machine_id || ''}
              onChange={(e, value) => {
                moduleData.machine_id = value;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
        <th style={{ fontSize: '20px' }} align="left" colSpan={2}>
          Date {due_date}
        </th>
      </tr>
      {/* <tr style={{ height: '50px' }}>
        <th style={{ fontSize: '20px' }}>Part Name : {part_name}</th>
        <th style={{ fontSize: '20px' }}>Part No. : {part_no}</th>
        <th colSpan={4} align="left" style={{ fontSize: '20px' }}>
          Audit Date : {due_date}
          Audit Date :{' '}
          {isView ? (
            formatDate(moduleData.d1)
          ) : (
            <DatePickerMui
              label=""
              value={moment(moduleData.d1)}
              onChange={(date) => {
                moduleData.d1 = date;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
      </tr> */}

      <tr style={{ height: '50px', fontSize: '20px', background: '#38d9a9' }}>
        {heading.map((header,index:any) => (
          <th key={header}>{header}</th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
